var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 33C26.0604 33 33 26.0604 33 17.5C33 8.93959 26.0604 2 17.5 2C8.93959 2 2 8.93959 2 17.5C2 26.0604 8.93959 33 17.5 33Z",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1367 13.625C10.1367 13.1111 10.3408 12.6183 10.7042 12.255C11.0676 11.8916 11.5604 11.6875 12.0742 11.6875C12.5881 11.6875 13.0809 11.8916 13.4442 12.255C13.8076 12.6183 14.0117 13.1111 14.0117 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7617 13.625C21.7617 13.3706 21.8118 13.1186 21.9092 12.8836C22.0066 12.6485 22.1493 12.4349 22.3292 12.255C22.5091 12.0751 22.7227 11.9324 22.9578 11.835C23.1928 11.7376 23.4448 11.6875 23.6992 11.6875C23.9537 11.6875 24.2056 11.7376 24.4407 11.835C24.6757 11.9324 24.8893 12.0751 25.0692 12.255C25.2492 12.4349 25.3919 12.6485 25.4892 12.8836C25.5866 13.1186 25.6367 13.3706 25.6367 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4542 25.3087C12.0173 24.1883 12.872 23.2404 13.9284 22.5648C14.9848 21.8892 16.2037 21.5108 17.457 21.4696C18.7103 21.4284 19.9515 21.7257 21.05 22.3304C22.1485 22.9351 23.0637 23.8248 23.6992 24.9057",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoor);
export default __webpack_public_path__ + "static/media/poor.a04c4b5d03c5fcf2ba347cca6cb5add0.svg";
export { ForwardRef as ReactComponent };